import type { LabRemoteConfigKeys } from 'constants/lab'
import { useAppSelector } from 'hooks/reduxHooks'

export const useLabRemoteConfig = (key: LabRemoteConfigKeys): App.LabRemoteConfigResult | undefined => {
  return useAppSelector((state) => state.system.features.remoteConfigFlags[key])
}
